var _polygon, _polygon2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBetslipPrematch = function SvgBetslipPrematch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "583.003px",
    height: "212.604px",
    viewBox: "0 0 583.003 212.604",
    enableBackground: "new 0 0 583.003 212.604",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pre_match_grad_1",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8506,
    y1: 106.3018,
    x2: 583.0029,
    y2: 106.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F84E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7163,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#pre_match_grad_1)",
    points: "583.003,0 487.422,0 249.971,0 191,0 65.851,212.603 249.971,212.603 487.422,212.603  487.422,212.604 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1F84E6",
    points: "31,0 0,0 0,212.604 31,212.604 156.333,0 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetslipPrematch, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNTgzLjAwM3B4IiBoZWlnaHQ9IjIxMi42MDRweCIgdmlld0JveD0iMCAwIDU4My4wMDMgMjEyLjYwNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTgzLjAwMyAyMTIuNjA0Ig0KCSB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxsaW5lYXJHcmFkaWVudCBpZD0icHJlX21hdGNoX2dyYWRfMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSI2NS44NTA2IiB5MT0iMTA2LjMwMTgiIHgyPSI1ODMuMDAyOSIgeTI9IjEwNi4zMDE4Ij4NCgk8c3RvcCAgb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojMUY4NEU2Ii8+DQoJPHN0b3AgIG9mZnNldD0iMC43MTYzIiBzdHlsZT0ic3RvcC1jb2xvcjojRkZGRkZGO3N0b3Atb3BhY2l0eTowIi8+DQo8L2xpbmVhckdyYWRpZW50Pg0KPHBvbHlnb24gZmlsbD0idXJsKCNwcmVfbWF0Y2hfZ3JhZF8xKSIgcG9pbnRzPSI1ODMuMDAzLDAgNDg3LjQyMiwwIDI0OS45NzEsMCAxOTEsMCA2NS44NTEsMjEyLjYwMyAyNDkuOTcxLDIxMi42MDMgNDg3LjQyMiwyMTIuNjAzIA0KCTQ4Ny40MjIsMjEyLjYwNCAiLz4NCjxwb2x5Z29uIGZpbGw9IiMxRjg0RTYiIHBvaW50cz0iMzEsMCAwLDAgMCwyMTIuNjA0IDMxLDIxMi42MDQgMTU2LjMzMywwICIvPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };